var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCollapse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 12.304c0 5.168 4.298 9.357 9.6 9.357s9.6-4.19 9.6-9.357m2.4 0C24 18.764 18.627 24 12 24S0 18.763 0 12.304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.066 13.258 9.894.126a.991.991 0 0 0 1.004-1.004 1.044 1.044 0 0 0-1.03-1.03l-9.894-.127a.991.991 0 0 0-1.004 1.004 1.044 1.044 0 0 0 1.03 1.03z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCollapse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-collapse.1978b964b37c68d20959e33ed0619691.svg";